<template>
  <header class="c-container__header">
    <template v-if="webshopHtmlHeader">
      <div v-html="webshopHtmlHeader"></div>
    </template>
    <h1 v-else class="c-container__title u-text-center">{{ webshopTitle }}</h1>
    <ul class="c-breadcrumbs">
      <li class="c-breadcrumb" :class="{ 'c-breadcrumb--current': isActive('klas') }">
        <router-link :to="{ name: 'klas' }" v-if="!isDisabled">Start</router-link>
        <template v-else>Start</template>
      </li>
      <li class="c-breadcrumb" :class="{ 'c-breadcrumb--current': isActive('cataloog') }">
        <router-link :to="{ name: 'cataloog', params: { klasId: klasId } }" v-if="!isDisabled && hasValidKlas">Cataloog</router-link>
        <template v-else>Cataloog</template>
      </li>
      <li class="c-breadcrumb" :class="{ 'c-breadcrumb--current': isActive('besteloverzicht') }">
        <router-link :to="{ name: 'besteloverzicht' }" v-if="!isDisabled && hasValidOrderlines">Besteloverzicht</router-link>
        <template v-else>Besteloverzicht</template>
      </li>
      <li class="c-breadcrumb" :class="{ 'c-breadcrumb--current': isActive('betaalformulier') }">
        <router-link :to="{ name: 'betaalformulier' }" v-if="!isDisabled && hasValidOrderlines">Betaling</router-link>
        <template v-else>Betaling</template>
      </li>
      <li class="c-breadcrumb" :class="{ 'c-breadcrumb--current': isActive('bevestiging', false) }">
        <router-link :to="{ name: 'bevestiging' }" v-if="!isDisabled && hasValidContact">Bevestiging</router-link>
        <template v-else>Bevestiging</template>
      </li>
    </ul>
  </header>
</template>

<script>
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { computed } from "vue";

export default {
  setup() {
    const router = useRouter();
    const store = useStore();

    const route = computed(() => router.currentRoute.value);
    const isActive = computed(
      () =>
        (name, exact = true) =>
          route.value.name === name || (!exact && route.value.matched.some((m) => m.name === name))
    );
    const isDisabled = computed(() => route.value.meta && route.value.meta.disableNavigation);
    const klasId = computed(() => store.state.orders.order.klasId || "KLAS_ID"); // use placeholder -> param klasId is required for some routes
    const hasValidKlas = computed(() => store.getters["orders/hasValidKlas"]);
    const hasValidOrderlines = computed(() => store.getters["orders/hasValidOrderlines"]);
    const hasValidContact = computed(() => store.getters["orders/hasValidContact"]);
    const isValidOrder = computed(() => store.getters["orders/isValidOrder"]);

    const webshopTitle = computed(() => (route.value.meta && route.value.meta.webshopTitle) || store.state.webshop.title);
    const webshopHtmlHeader = computed(() => store.getters["webshop/header"]);

    return {
      webshopTitle,
      webshopHtmlHeader,

      isActive,
      isDisabled,
      klasId,
      hasValidKlas,
      hasValidOrderlines,
      hasValidContact,
      isValidOrder,
    };
  },
};
</script>
